import React from 'react'
import { BackgroundF2ECss } from './style'
export default function BackgroundF2E() {
    return (
        <BackgroundF2ECss className="section4 position-absolute">
            <ul className="loop text-blakc">
                <li>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                </li>
                <li>
                    <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;THE F2E THE F2E THE F2E THE F2E </span>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                </li>
                <li>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                </li>
                <li>
                    <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;THE F2E THE F2E THE F2E THE F2E </span>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                </li>
                <li>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                </li>
                <li>
                    <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;THE F2E THE F2E THE F2E THE F2E </span>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                </li>
                <li>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                </li>
                <li>
                    <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;THE F2E THE F2E THE F2E THE F2E </span>
                    <span> THE F2E THE F2E THE F2E THE F2E </span>
                </li>
            </ul>
        </BackgroundF2ECss>
    )
}
